import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { PROPERTY } from "@clooper/core";
import { faCheck } from "@fortawesome/pro-light-svg-icons";
import { BsModalRef, ModalOptions } from "ngx-bootstrap/modal";
import { CustomRadioComponent } from "../custom-radio/custom-radio.component";


@Component({
    selector: 'app-properties-filter',
    templateUrl: './properties-filter.component.html',
    styleUrls: ['./properties-filter.component.scss']
  })
  
export class PropertiesFilterComponent implements OnInit {
  icons = {
    check: faCheck
  }
  bedForm = new FormGroup({
    bed: new FormControl(0, [Validators.required, Validators.min(0)]),    
  });
  guestForm = new FormGroup({
    guest: new FormControl(0, [Validators.required, Validators.min(0)]),
  });
  bathroomForm = new FormGroup({
    bathroom: new FormControl(0, [Validators.required, Validators.min(0)]),
  });
distance: any = [
  {name: '10 Miles', value: PROPERTY.PROPERTY_DISTANCE.TEN_MILES},
  {name: '60 Miles', value: PROPERTY.PROPERTY_DISTANCE.SIXTY_MILES},
  {name: '20 Miles', value: PROPERTY.PROPERTY_DISTANCE.TWENTY_MILES},
  {name: '80 Miles', value: PROPERTY.PROPERTY_DISTANCE.EIGHTY_MILES},
  {name: '30 Miles', value: PROPERTY.PROPERTY_DISTANCE.THIRTY_MILES},
  {name: '100 Miles', value: PROPERTY.PROPERTY_DISTANCE.HUNDRED_MILES},
  {name: '50 Miles', value: PROPERTY.PROPERTY_DISTANCE.FIFTY_MILES},
]
propertyTypeList: any = [
  {name: 'Apartment', value: 1, label: 'Apartment'},
  {name: 'Hotel', value: 2, label: 'Hotel'},
]


propertyFaciliies = [
  {name: PROPERTY.STANDARD_FACILITIES.WIFI, label: 'Wi-Fi', checked: false},
  {name: PROPERTY.STANDARD_FACILITIES.AIR_CONDITIONING, label: 'Air conditioning', checked: false},
  {name: PROPERTY.STANDARD_FACILITIES.FULLY_EQUIPED_KITCHEN, label: 'Full Equiped Kitchen', checked: false},
  {name: PROPERTY.STANDARD_FACILITIES.HOUSEKEEPING, label: 'Housekeeping', checked: false},
  {name: PROPERTY.STANDARD_FACILITIES.WORK_DESK, label: 'Work desk', checked: false},
  {name: PROPERTY.STANDARD_FACILITIES.OUTSIDE_SPACE, label: 'Outside space', checked: false},
]
extraFeatures = [
  {name: PROPERTY.EXTRA_FEATURES.CONCIERGE, label: 'Concierge', checked: false},
  {name: PROPERTY.EXTRA_FEATURES.RESTAURANT_BAR, label: 'Restaurant / Bar', checked: false},
  {name: PROPERTY.EXTRA_FEATURES.SELF_CHECKIN, label: 'Self check-in', checked: false},
  {name: PROPERTY.EXTRA_FEATURES.SECURITY, label: '24/7 Security', checked: false},
  {name: PROPERTY.EXTRA_FEATURES.MEETING_ROOM, label: 'Meeting room', checked: false},
  {name: PROPERTY.EXTRA_FEATURES.GYM, label: 'Gym', checked: false},
  {name: PROPERTY.EXTRA_FEATURES.ONSITE_PARKING, label: 'Onsite parking', checked: false},
  {name: PROPERTY.EXTRA_FEATURES.OFFSITE_PARKING, label: 'Offsite parking', checked: false},
]
homeRules = [
  {name: PROPERTY.HOUSE_RULES.PETS_ALLOWED, label: 'Pets allowed', checked: false},
  {name: PROPERTY.HOUSE_RULES.SMOKING_ALLOWED, label: 'Smoking allowed', checked: false},
]
healthAlarm = [
  {name: PROPERTY.SAFETY_CHECKS.SMOKE_ALARM, label: 'Smoke alarm', checked: false},
  {name: PROPERTY.SAFETY_CHECKS.CO_ALARM, label: 'CO Alarm', checked: false},
]
extras: string[] = []
safety: string[] = []
facilities: string[] = []
propertyType: string[] = []
houseRules: string[] = [];
filterParams : any = {};
@ViewChild('radiusElement') radiusElement: CustomRadioComponent;


resetFilter: any = {radius: '', latlng: ''}
  constructor(
    public bsModalRef: BsModalRef,
    public options: ModalOptions,
    // public listingService: ListingService,
    private route: ActivatedRoute,
    private router: Router

  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      if (Object.keys(params).length !== 0) {
        this.filterParams = params;
        this.resetFilter = {radius: 10, latlng: params.latlng}
      }
    });

    this.onBedChanges();
    this.onGuestChanges();
    this.onBathRoomChanges();
    this.checkBedChanges()
    this.checkGuestChanges()
    this.checkBathroomChanges()
    this.checkFacilitiesChanges()
    this.checkPropertyTypeChanges()
    this.checkExtraRuleChanges()
    this.checkHomeRuleChanges()
    this.checkSafetyChanges()
  }

  ngAfterViewInit(): void {
    const data = {
      name: `${this.filterParams.radius + ' ' + 'Miles'}`,
      value: `${this.filterParams.radius}`,
      label : `${this.filterParams.radius}`
  }
    this.radiusElement.change(data)

  }

  onBedChanges(): void {
    this.bedForm.valueChanges.subscribe(val => {
      let data = {...this.filterParams}
      if (val.bed !== 0) {
        data.beds = val.bed
        const queryParams: any = { ...data}
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
      } else {
        delete data.beds
        const queryParams: any = { ...data }
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });

      }

    });
  }


  onGuestChanges(): void {
    this.guestForm.valueChanges.subscribe(val => {
      let data = {...this.filterParams}
      if (val.guest !== 0) {
        data.guests = val.guest
        const queryParams: any = { ...data}
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
      } else {
        delete data.guests
        const queryParams: any = { ...data }
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });

      }

  
    });
  }
  onBathRoomChanges(): void {
    this.bathroomForm.valueChanges.subscribe(val => {
      let data = {...this.filterParams}

      if (val.bathroom !== 0) {

        data.bathrooms = val.bathroom;
        const queryParams: any = { ...data}
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
      } else {
        delete data.bathrooms
        const queryParams: any = { ...data }
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });

      }
    });
  }
  
  getPropertyType(event: any, index: number) {
    let params = {...this.filterParams}
    if (event.target.checked === true) {
      this.propertyTypeList[index].checked = true;
      this.propertyType.push(event.target.value)
      const data = this.propertyType.join(',')
      params.property_type = data;
      const queryParams: any = { ...params }
      this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
    } else {
      this.propertyType = this.propertyType.filter((item: any ) => item !== event.target.value);
      if (this.propertyType.length !== 0) {
        const data = this.propertyType.join(',')
        params.property_type = data;
        const queryParams: any = { ...params }
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
      } else {
        delete params.property_type
        const queryParams: any = { ...params }
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });

      }
      
    }
  }
  
  getFacilities(event: any, index: number) {
    let params = {...this.filterParams}
    if (event.target.checked === true) {
      this.propertyFaciliies[index].checked = true;
      this.facilities.push(event.target.value)
      const data = this.facilities.join(',')
      params.facilities = data;
      const queryParams: any = { ...params }
      this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
    } else {
      this.facilities = this.facilities.filter((item: any ) => item !== event.target.value);
      if (this.facilities.length !== 0) {
        const data = this.facilities.join(',')
        params.facilities = data;
        const queryParams: any = { ...params }
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
      } else {
        delete params.facilities
        const queryParams: any = { ...params }
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });

      }
      
    }
  }

  getExtras(event: any, index: number) {
        let params = {...this.filterParams}

    if (event.target.checked === true) {
      this.extraFeatures[index].checked = true;
      this.extras.push(event.target.value)
      const data = this.extras.join(',')
      params.extra_features = data;
      const queryParams: any = { ...params}
      this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
    } else {
      this.extras = this.extras.filter((item: any ) => item !== event.target.value);
      if (this.extras.length !== 0) {
        const data = this.extras.join(',')
        params.extra_features = data;
        const queryParams: any = { ...params }
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
      } else {
        delete params.extra_features
        const queryParams: any = { ...params }
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });

      }      
    }

  }

  setHomeRules(event: any, index: number) {
    let params = {...this.filterParams}

    if (event.target.checked === true) {
      this.homeRules[index].checked = true;
      this.houseRules.push(event.target.value)
      const data = this.houseRules.join(',')
      params.house_rules = data;
      const queryParams: any = { ...params}
      this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
    } else {
      this.houseRules = this.houseRules.filter((item: any ) => item !== event.target.value);
      if (this.houseRules.length !== 0) {
        const data = this.houseRules.join(',')
        params.house_rules = data;
        const queryParams: any = { ...params }
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
      } else {
        delete params.house_rules
        const queryParams: any = { ...params }
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });

      }      
    }

  }

  setSafety(event: any, index: number) {
    let params = {...this.filterParams}

    if (event.target.checked === true) {
      this.healthAlarm[index].checked = true;
      this.safety.push(event.target.value)
      const alarm = this.safety.join(',')
      params.alarms = alarm;
      const queryParams: any = { ...params}
      this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
    } else {
      this.safety = this.safety.filter((item: any ) => item !== event.target.value);
      if (this.safety.length !== 0) {
        const data = this.safety.join(',')
        params.alarms = data;
        const queryParams: any = { ...params }
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
      } else {
        delete params.alarms
        const queryParams: any = { ...params }
        this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });

      } 
      
    }

  }

  setDistance(event: {name: string, value: string}) {
    let params = {...this.filterParams}
    params.radius = event.value;
    const queryParams: any = { ...params}
    this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });
  }
  
  resetFilters() {
    let params = {...this.filterParams}

    // Deletes added KEYS to the filterParams object
    delete params.facilities
    delete params.extra_features
    delete params.house_rules
    delete params.alarms
    delete params.property_type

    //  Reset all checked checkbox to default state

    this.propertyFaciliies.some((element: {checked: boolean}) => {
      element.checked = false;
    })
    this.extraFeatures.some((element: {checked: boolean}) => {
      element.checked = false;
    })
    this.homeRules.some((element: {checked: boolean}) => {
      element.checked = false;
    })
    this.healthAlarm.some((element: {checked: boolean}) => {
      element.checked = false;
    })
    this.propertyTypeList.some((element: {checked: boolean}) => {
      element.checked = false;
    })
    this.bedForm.controls.bed.setValue(0) 
    this.guestForm.controls.guest.setValue(0) 
    this.bathroomForm.controls.bathroom.setValue(0) 

    const queryParams: any = { ...this.resetFilter}
    this.router.navigate([], { queryParams, /* queryParamsHandling: 'merge' */ });

  }

 
  closeModal() {
    this.bsModalRef.hide();

  }


     // Prefil form when filter modal is reopened
     checkBedChanges() {
      if(this.filterParams.beds !== undefined && this.filterParams.beds !== '0') {
        this.bedForm.patchValue({
          bed: this.filterParams.beds
        })
      }
    }
    checkGuestChanges() {
      if(this.filterParams.guests !== undefined && this.filterParams.guests !== '0') {
        this.guestForm.patchValue({
          guest: this.filterParams.guests
        })
      }
    }
    checkBathroomChanges() {
      if(this.filterParams.bathrooms !== undefined && this.filterParams.bathrooms !== '0') {
        this.bathroomForm.patchValue({
          bathroom: this.filterParams.bathrooms
        })
      }
    }
    checkExtraRuleChanges() {
      if(this.filterParams.extra_features !== undefined) {
        let results = this.filterParams.extra_features.split(',')
        this.extraFeatures.filter((element: any, index: number) => {
          if (results.includes(element.label)) {
            this.extraFeatures[index].checked = true;
            this.extras.push(element.name)
          }
        });
       
      }
    }

    checkPropertyTypeChanges() {
      if(this.filterParams.property_type !== undefined) {
        let results = this.filterParams.property_type.split(',')
        this.propertyTypeList.filter((element: any, index: number) => {
          if (results.includes(element.label)) {
            this.propertyTypeList[index].checked = true;
            this.propertyType.push(element.name)
          }
        });
       
      }
    }


    checkFacilitiesChanges() {
      if(this.filterParams.facilities !== undefined) {
        let results = this.filterParams.facilities.split(',')
        this.propertyFaciliies.filter((element: any, index: number) => {
          if (results.includes(element.label)) {
            this.propertyFaciliies[index].checked = true;
            this.facilities.push(element.name)
          }
        });
       
      }
    }
    checkHomeRuleChanges() {
      if(this.filterParams.house_rules !== undefined) {
        let results = this.filterParams.house_rules.split(',')
        this.homeRules.filter((element: any, index: number) => {
          if (results.includes(element.label)) {
            this.homeRules[index].checked = true;
            this.houseRules.push(element.name)
          }
        });
       
      }
    }
    checkSafetyChanges() {
      if(this.filterParams.alarms !== undefined) {
        let results = this.filterParams.alarms.split(',')
        this.healthAlarm.filter((element: any, index: number) => {
          if (results.includes(element.name)) {
            this.healthAlarm[index].checked = true;
            this.safety.push(element.name)
          }
        });
       
      }
    }
  
}